import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricBookingCount extends MetricBase {
    constructor() {
        super({
            field: "metric_bookingcount",
            defaultVisibility: false,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.tripadvisor.bookingcount.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.bookingcount.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.bookingcount.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricBookingCount;
